import React from 'react';

const DealEtikett = ({ deal }) => {
  const dealText = () => {
    if (deal.combo) {
      return 'Ticket + Snack';
    }

    return 'Film Deal';
  };
  
  return (
    <div className="deal">
      <div className="deal-content">
        {dealText()}
        <span>{deal.price}&euro;</span>
      </div>
    </div>
  );
};

export default DealEtikett;
